// extracted by mini-css-extract-plugin
export var redoItem = "_gx-1";
export var redoTrigger = "_gx-0";